'use strict';
import angular from 'angular';
import $ from 'jquery';
import _ from 'lodash';

angular.module('workflowclient.ctrls', [])
    .controller('WorkflowClientViewController', WorkflowClientViewController);

WorkflowClientViewController.$inject = ['$rootScope', '$scope', '$timeout', '$stateParams', '$state', '$confirm', '$window', 'WorkflowClientService', 'OrdersService', 'FormService', 'DisplayService', 'UserService', 'CommentService', '$ioAlert', 'TaskService', 'MediaService', 'ModalService', '$modal', 'AppConfig'];

function WorkflowClientViewController($rs, $scope, $timeout, $stateParams, $state, $confirm, $window, WorkflowClientService, OrdersService, FormService, DisplayService, UserService, CommentService, $ioAlert, TaskService, MediaService, ModalService, $modal, AppConfig) {

    const WORKFLOW_TYPE_CLIENT = 3;

    $scope.clientId = $stateParams.id;
    $scope.currentUserId = $rs.userRole.id;
    $scope.client = null;
    $scope.creatives = [];
    $scope.clientActivity = null;
    $scope.formFields = null;
    $scope.formFieldGroups = null;
    $scope.displayGroups = {};
    $scope.loadComplete = false;
    $scope.isAdmin = false;
    $scope.showStartOver = false;
    $scope.associatedTasks = [];
    $scope.showAssociatedTasks = false;
    $scope.showOnDemandTasks = false;
    $scope.duplicateOnDemandTasks = false;
    $scope.historyTasks = [];
    $scope.showTaskProgress = false;
    $scope.showHistoryTaskProgress = false;
    $scope.on_demand_task_comment_required = false;
    $scope.model = {
        quickComment: null,
        onDemandTask: null,
        addOnDemandTask: null,
        addOnDemandTaskToggle: false
    };
    $scope.commentFilter = {
        items: [],
        search: ""
    };

    let getClient = function(clientId) {
        UserService.getClient(clientId).then(function(success) {
            $scope.client = UserService.client;
            loadDisplay();
            getCreatives(clientId);
        }, function(error) {
            $ioAlert.show('Error!', 'An error occurred getting the client information for client_id ' + clientId, 'error');
            $scope.loadComplete = true;
        });
    }

    let getOnDemandTasks = function() {
        TaskService.getOnDemandTasksForClient($scope.client.cluster_id).then(function() {
            $scope.onDemandTasks = TaskService.onDemandTasks;
            if (TaskService.onDemandTasks && TaskService.onDemandTasks.length > 0) {
                $scope.showOnDemandTasks = true;
                // Determine if there are duplicate tasks.  If it is the case, we will show additional information
                // (the workflow action name, for lack of anything better) to help tell them apart.
                const definitionsArray = $scope.onDemandTasks.map(task => task.definition);  // Extract only definitions and put in an array
                $scope.duplicateOnDemandTasks = new Set(definitionsArray).size !== definitionsArray.length;  // A set does not contain duplicate values...
            }
        }, function() {
            $ioAlert.show('Error getting client on demand Tasks!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    let getCreatives = function(clientId) {
        MediaService.getClientCreatives(clientId).then(function () {
            $scope.creatives = MediaService.creatives;
        }, function () {
            console.log("Error getting creatives for client: " + clientId);
        });
    };

    let hiddenByParent = function(field) {
        if (field.parent_id) {
            let parent_field = null;
            for (let i = 0; i < $scope.formFields.length; i++) {
                if ($scope.formFields[i]['id'] == field.parent_id) {
                    parent_field = $scope.formFields[i];
                    break;
                }
            }

            if (parent_field && $scope.client.hasOwnProperty(parent_field.field_name)) {
                let parentValues = $scope.client[parent_field.field_name];
                if (Array.isArray(parentValues)) {
                    if (Array.isArray(parentValues[0])) {
                        for (let i in parentValues) {
                            if (field.parent_trigger_id.indexOf(parentValues[i][0]) != -1) { // multi select
                                return false;
                            }
                        }
                    } else if (field.parent_trigger_id.indexOf(parentValues[0]) != -1) { // single select
                        return false;
                    }
                } else if (field.parent_trigger_id.indexOf(parentValues) != -1) { // checkbox
                    return false;
                }
                return true;
            } else {
                return true;
            }
        }
        return false;
    }

    let buildDisplayData = function () {
        var staticCustomerInfo = {};
        staticCustomerInfo.title = "Basic Information";
        staticCustomerInfo.data = [];
        staticCustomerInfo.data.push({ 'Client': $scope.client.company_name, formFieldName: 'company_name' });
        staticCustomerInfo.data.push({ 'Advertiser Account Id': $scope.client.billing_id, formFieldName: 'billing_id' });
        staticCustomerInfo.data.push({ 'CRM Customer Id': $scope.client.crm_id, formFieldName: 'crm_id' });
        staticCustomerInfo.data.push({ 'Status Name': $scope.client.io_statuses[$scope.client.iotool_status], formFieldName: 'iotool_status' });
        if ($scope.client.workflow_step) {
            staticCustomerInfo.data.push({'Workflow Step Description': $scope.client.workflow_step.description});
        } else {
            staticCustomerInfo.data.push({'Workflow Step Description': '(There is no associated workflow for this client)'});
        }
        staticCustomerInfo.displayOrder = -1;  // Make sure it is first
        $scope.displayGroups['client information'] = staticCustomerInfo;

        let formFieldGroups = $scope.formFieldGroups;
        for (let x = 0; x < formFieldGroups.length; x++) {
            let formFieldGroup = formFieldGroups[x];
            let section = {};
            section.title = formFieldGroup.group_name;
            section.data = [];
            section.displayOrder = formFieldGroup.group_display_order;

            if(formFieldGroup.hideForCondition) {
                let conditionId = "0";
                switch(formFieldGroup.hideForConditionType) {
                    case "Role Type":
                        conditionId = $rs.userRole.role_id;
                        break;
                }
                if(formFieldGroup.hideForCondition.includes(conditionId)) {
                    continue;
                }
            }
            $scope.displayGroups[formFieldGroup.id] = section;
        }

        if ($scope.formFields && $scope.formFields.length) {
            for (let i = 0; i < $scope.formFields.length; i++) {
                const formField = $scope.formFields[i];
                if (!hiddenByParent(formField)) {
                    if (formField.input_type === "readonly") {
                        if (formField.default_value) {
                            $scope.client[formField.field_name] = formField.default_value;
                        } else if (formField.cascading_field_name) {
                            let cascadingValue = $scope.client ? $scope.client[formField.cascading_field_name] : null;
                            if (cascadingValue != undefined) {
                                $scope.client[formField.field_name] = cascadingValue;
                            }
                        }
                    }
                    if ($scope.client.hasOwnProperty(formField.field_name)) {
                        let group = $scope.displayGroups[formField.group_id];
                        if (group) {
                            let displayPair = DisplayService.applyTransformation(formField,
                                $scope.client[formField.field_name]);
                            displayPair.formFieldType = ['hyperlink'].includes(formField.data_type) ?
                                formField.data_type : formField.input_type;
                            displayPair.formFieldName = formField.field_name;
                            group.data.push(displayPair);
                        }
                    }
                } else {
                    delete $scope.client[formField.field_name];
                }
            }
        }

        // Remove empty sections from groups
        for (let index in $scope.displayGroups) {
            if ($scope.displayGroups.hasOwnProperty(index)) {
                if ($scope.displayGroups[index].data.length == 0) {
                    delete $scope.displayGroups[index];
                }
            }
        }
    }

    let getClientActivity = function() {
        WorkflowClientService.getClientActivity($scope.clientId).then(function(data) {
            $scope.originalClientActivityLog = _.clone(data);  // Keep original for Show Audit button.
            $scope.clientActivity = data;
            let auditArray = {};
            if ($scope.clientActivity != null) {
                for (let i = 0, len = $scope.clientActivity.length; i < len; i++) {
                    if ($scope.clientActivity[i].action?.startsWith('update')) {
                        let jsonObj = JSON.parse($scope.clientActivity[i].delta);
                        let keys = Object.keys(jsonObj);
                        keys.forEach(function(value) {
                            let obj = {};
                            obj.field = value;
                            obj.before = jsonObj[value].before;
                            obj.after = jsonObj[value].after;
                            obj.date = $scope.clientActivity[i].created_at;
                            obj.userName = $scope.clientActivity[i].first_name + " " + $scope.clientActivity[i].last_name;
                            if (auditArray[value]) {
                                auditArray[value].push(obj);
                            } else {
                                auditArray[value] = [obj];
                            }
                        });
                    }
                }
                $scope.clientActivity = auditArray;

                if ($scope.formFields && $scope.formFields.length) {
                    for (let i = 0; i < $scope.formFields.length; i++) {
                        let formField = $scope.formFields[i];
                        if(!$scope.client.hasOwnProperty(formField.field_name) &&
                            $scope.clientActivity.hasOwnProperty(formField.field_name) &&
                            !hiddenByParent(formField)) {
                            let group = $scope.displayGroups[formField.group_id];
                            if (group) {
                                let displayPair = {};
                                displayPair[formField.display_name] = "";
                                displayPair.formFieldType = formField.input_type;
                                displayPair.formFieldName = formField.field_name;
                                group.data.push(displayPair);
                            }
                        }
                    }
                }

                // Show the field with empty value when it has a activity history
                _.each($scope.displayGroups, function(groupObj) {
                    _.each(groupObj.data, function(item) {
                        if ($scope.clientActivity[item.formFieldName]) {
                            item.isEdited = true;
                            item.fieldAuditHistory = $scope.clientActivity[item.formFieldName];
                        } else {
                            item.isEdited = false;
                        }
                    });
                });

                FormService.getTaskFormFieldsForClient($scope.clientId).then(function (data) {
                    if (!data.formFields || data.formFields.constructor.name !== 'Array') {
                        return
                    }

                    let group = {
                        title: 'Task Information',
                        data: [],
                    };
                    data.formFields.forEach(function (formField) {
                        let attrValue = $scope.client[formField.field_name]
                        if (attrValue) {
                            let displayPair = DisplayService.applyTransformation(formField, attrValue);
                            displayPair.formFieldType = ['hyperlink'].includes(formField.data_type) ?
                                formField.data_type : formField.input_type;
                            displayPair.formFieldName = formField.field_name;
                            group.data.push(displayPair);
                        }
                    })

                    if (group.data.length === 0) {
                        return;
                    }

                    $scope.displayGroups['__task__'] = group;
                });
            }
        }, function() {
        });
    };

    $scope.backToClients = function() {
        if ($rs.user.user.use_nui) {
            window.location = AppConfig.NUI_PATH + '#/clients';
        } else {
            $state.go('ioclients');
        }
    };

    $scope.showChanges = function(changesObj) {
        let list = changesObj.fieldAuditHistory;
        // This is not a typo, we are using the lineItemChanges modal even for client changes.
        $modal.open(ModalService.returnModalType('lineItemChanges', { data: { list: list } }));
    };

    $scope.loadingStep = false;
    $scope.stepError = false;

    let getWorkflowSteps = function(clientId) {
        $scope.loadingStep = true;
        WorkflowClientService.getStepsForClient(clientId).then(function(success) {
            if ($scope.client.workflow_step_id) {
                for (let i = 0; i < success.length; i++) {
                    success[i].isCurrentStep = (success[i].id == $scope.client.workflow_step_id);
                }
                if ($scope.client.completed_workflow_steps && $scope.client.completed_workflow_steps.length) {
                    _.each($scope.client.completed_workflow_steps, function(completed) {
                        _.each(success, function(steps) {
                            if (steps.id == completed.id) {
                                steps.completedStep = true;
                            }
                        });
                    });
                }
            } else {
                $scope.stepError = true;
            }

            $scope.client.steps = success;
            $scope.loadingStep = false;

        }, function() {
            $scope.loadingStep = false;
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });

    };

    let setDefaultActiveSideTab = function() {
        $scope.sideActiveTab = 'comments';
    };

    let loadDisplay = function() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Client Information";

        const clusterId = $scope.client.cluster_id;
        $rs.$broadcast('fetchTaggingUsers', clusterId);

        FormService.getClientFormFieldGroups(clusterId).then(function(data) {
            $scope.formFieldGroups = data.formFieldGroups;
            _.each($scope.formFieldGroups, function(group) {
                group.group_display_order = parseInt(group.group_display_order);
            });

            FormService.getClientFormFields(clusterId, true, false).then(function(data) {
                $scope.formFields = data.formFields;
                buildDisplayData();
                getClientActivity();
                $rs.loadingInProgress = false;
                $scope.loadComplete = true;
                $scope.showTasks(false);
                getExistingComments();
                getOnDemandTasks();
                getWorkflowSteps($scope.clientId);
                setDefaultActiveSideTab();

            }, function() {
                console.log("Error getting form fields for client: " + $scope.clientId);
                $rs.loadingInProgress = false;
            });
        }, function() {
            console.log("error getting form field groups for client: " + $scope.clientId);
            $rs.loadingInProgress = false;
        });
    };

    let getExistingComments = function() {
        CommentService.getClientComments($scope.clientId, $scope.commentFilter.search).then(function() {
            $scope.client.comments = CommentService.comments;
        }, function() {
            console.log("Error getting comments for client: " + $scope.clientId);
        });
    };

    /*
     * commentSubmitDisabled is used for disable the 'add' button when
     * the api call addComment is running
     */
    $scope.commentSubmitDisabled = false;

    /*
     * $scope.model.quickComment is the content of the comment
     * $scope.showOnDemandTasks is the condition to show add task functionality
     * $scope.model.addOnDemandTask is the checkbox of add task
     * $scope.model.onDemandTask is the selected on-demand task
     */
    $scope.addComment = function() {
        if ($scope.showOnDemandTasks && $scope.model.addOnDemandTask) {
            if ($scope.on_demand_task_comment_required && !$scope.model.quickComment) {
                $ioAlert.show('Error!', 'Please enter a comment.', 'error');
                return;
            }
            if (!$scope.model.onDemandTask) {
                $ioAlert.show('Error!', 'Please select a task', 'error');
                return;
            }
        } else if (!$scope.model.quickComment) {
            $ioAlert.show('Error!', 'Please enter a comment.', 'error');
            return;
        }

        $scope.commentSubmitDisabled = true;

        CommentService.addClientComment($scope.clientId,
            $scope.model.quickComment,
            false,
            $scope.model.addOnDemandTask,
            $scope.model.onDemandTask,
        ).then(function() {
            $scope.model.onDemandTask = null; // clear task select field
            $scope.model.addOnDemandTask = false; // clear checkbox
            $scope.model.addOnDemandTaskToggle = false; // hide task select field
            $scope.model.quickComment = null;
            $scope.commentSubmitDisabled = false;
            $scope.showTaskProgress = false;
            getExistingComments();
        }, function() {
            $scope.commentSubmitDisabled = false;
            console.log("Error saving comment or task for client: " + $scope.clientId);
        });
    };

    $scope.naturalSortByIdDesc = function(a, b) {
        return FormService.naturalSortByIdDesc(a, b);
    }

    $scope.showTasks = function(showAll) {
        if (showAll) {
            if ($scope.showHistoryTaskProgress === false) {
                $scope.showHistoryTaskProgress = true;
                TaskService.getTaskAssignmentsForClient($scope.clientId).then(function(taskAssignments) {
                    $scope.historyTasks = taskAssignments;
                }, function() {
                    $ioAlert.show('Error getting Tasks!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });
            }
        } else {
            if ($scope.showTaskProgress === false) {
                $scope.showTaskProgress = true;
                TaskService.getOpenTaskAssignmentsForClient($scope.clientId).then(function(taskAssignments) {
                    $scope.associatedTasks = taskAssignments;
                    calculateDueDates($scope.associatedTasks);
                }, function() {
                    $ioAlert.show('Error getting Tasks!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });
            }
        }
    };

    let getCommentFilterItems = function() {
        TaskService.getTasksList().then(function(response) {
            $scope.commentFilter.items = [];
            if (response) {
                _.each(response, function(item) {
                    if (item.reference_table == "client"){
                        $scope.commentFilter.items.push({id: item.id, definition: item.definition});
                    }
                });
            }
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    /*
     * Audit history button
     */
    $scope.auditHistory = function() {
        $state.go('auditHistory', {
            type: 'client',
            id: $scope.clientId,
            activityLog: $scope.originalClientActivityLog
        });
    };

    /*
     * Workflow Log button
     */
    $scope.workflowLogHistory = function() {
        $state.go('workflowLogHistory', {
            type: 'client',
            id: $scope.clientId
        });
    };

    /*
     * Edit Client button
     */
    $scope.editClientRecord = function() {
        if ($rs.user.user.use_nui) {
            window.location = AppConfig.NUI_PATH + '#/clients/' + $scope.client.id;
        } else {
            let $path = AppConfig.TA_URL + '#/clients/detail/';

            if ($rs.userRole.permissions === 'adops') {
                $path = AppConfig.IO_URL + '#/admin/ioclients/edit/';
            }
            $window.open($path + $scope.client.id, '_self');
        }
    };

    /*
     * Workflow start over button
     */
    $scope.workflowStartOver = function() {
        $confirm.open({
            size: 'sm',
            text: 'You are about to reset this workflow. Are you sure you want to proceed?'
        }).then(function() {
            OrdersService.workflowReset(WORKFLOW_TYPE_CLIENT, $scope.clientId).then(function() {
                $ioAlert.show('', 'Workflow reset successful', 'success');
                $scope.activateCommentsTab();
                getClient($scope.clientId);
                $scope.showHistoryTaskProgress = false;
                $scope.showTaskProgress = false;
            }, function(error) {
                $ioAlert.show('Error!', error, 'error');
            });
        }, function() {})
    }

    $scope.deleteComment = function(commentId) {
        $confirm.open({
            size: 'sm',
            text: 'Are you sure you want to delete this Comment?'
        }).then(function() {
            CommentService.deleteComment(commentId).then(function() {
                getExistingComments();
                $ioAlert.show('Comment deleted', 'Comment has been successfully deleted', 'success');
            }, function() {
                console.log("error deleting comment");
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }, function() {})
    };

    /*
     * Helper function to calculate the number of overdue and escalated tasks
     */
    let calculateDueDates = function(tasks) {
        $scope.escalatedTasks = 0;
        $scope.overDueTasks = 0;
        _.each(tasks, function(task) {
            if (task.due_date_flag == 1) {
                $scope.overDueTasks++;
            } else if (task.escalate_date_flag == 1) {
                $scope.escalatedTasks++;
            }
        });
    };

    let applyPermissions = function() {
        if ($rs.userRole.permissions.indexOf("adops") > -1 ||
            $rs.userRole.permissions == 'superadmin' ||
            $rs.userRole.permissions == 'sales,admin') {
            $scope.isAdmin = true;
        }

        if ($rs.userRole.permissions && ($rs.userRole.permissions == 'adops,admin' ||
            $rs.userRole.permissions == 'superadmin')) {
            $scope.showStartOver = true;
        }
    };

    $scope.activateTab = function(tab) {
        $scope.sideActiveTab = tab;
    };

    $scope.activateCommentsTab = function() {
        $scope.activateTab('comments');
    };

    $scope.activateTasksTab = function() {
        $scope.activateTab('tasks');
    };

    $scope.activateTasksHistoryTab = function() {
        $scope.activateTab('tasks-history');
    };

    $scope.isTabActive = function(tab) {
        return $scope.sideActiveTab === tab;
    };

    $scope.isCommentsTabActive = function() {
        return $scope.isTabActive('comments')
    };

    $scope.isTasksTabActive = function() {
        return $scope.isTabActive('tasks');
    };

    $scope.isTasksHistoryTabActive = function() {
        return $scope.isTabActive('tasks-history');
    };

    const initInstanceSettings = function() {
        let params = [
            'on_demand_task_comment_required',
        ];
        FormService.getInstanceSettingArray(params).then(function(data) {
            if (data?.instance_settings) {
                const on_demand_task_comment_required = data.instance_settings.on_demand_task_comment_required;
                $scope.on_demand_task_comment_required = (on_demand_task_comment_required === '1');
            } else {
                $ioAlert.show('Error!', 'Cannot find any instance setting', 'error');
            }
        }, function(error) {
            console.log(error);
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    let init = function() {
        $state.go('viewWorkflowClient');
        applyPermissions();
        getClient($scope.clientId);
        getCommentFilterItems();
        initInstanceSettings();
    };

    init();
}
